var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    class: 'text-lg text-gray-600 grid place-content-center gap-x-4 ' + _vm.heightLine + ' ' + _vm.grid
  }, [_vm._t("header")], 2), _vm._v(" "), _vm._t("errorCases"), _vm._v(" "), _vm.loading ? _c('div', {
    staticClass: "w-full h-full flex justify-center items-center"
  }, [_c('span', {
    staticClass: "p-7 border-t-2 border-r-2 rounded-full animate-spin border-indigo-600"
  })]) : _vm._e(), _vm._v(" "), _vm.isListdisplayed && !_vm.loading ? _c('div', _vm._l(_vm.listItems, function (item, num) {
    return _c('accordion-item', {
      key: _vm.labelKey + (item.id ? item.id : num),
      class: {
        'odd:bg-indigo-100 odd:bg-opacity-50 bg-white': !_vm.disabled(item),
        'odd:bg-indigo-100 bg-opacity-50 bg-white opacity-50': _vm.disabled(item)
      },
      staticStyle: {
        "padding": "0 !important"
      },
      attrs: {
        "disabled": _vm.disabled(item),
        "is-accordion-displayed": _vm.numToDisplay === num,
        "grid": _vm.grid,
        "height-line": _vm.heightLine
      },
      on: {
        "clickOnItem": function ($event) {
          !_vm.disabled(item) ? _vm.displayNum(num) : _vm.displayDis(num);
        }
      },
      scopedSlots: _vm._u([{
        key: "description",
        fn: function () {
          return [_vm._t("accordionDescription", null, {
            "item": item,
            "num": num
          })];
        },
        proxy: true
      }, {
        key: "content",
        fn: function () {
          return [_vm._t("accordionContent", null, {
            "item": item,
            "num": num
          })];
        },
        proxy: true
      }], null, true)
    });
  }), 1) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }